<template>
  <div class="is-card has-text-centered">
    <h1 class="title has-text-giada-green has-margin-t-4">{{isModalTextTitle}}</h1>
    <h4 class="has-text-white">{{isModalTextSubTitleThanks}}</h4>
    <h4 class="has-text-white has-margin-b-4">{{isModalTextSubTitle}}</h4>
    <h3 class="subtitle has-text-white has-margin-b-4">{{isModalTextPosition}}</h3>
    <div class="button has-text-weight-bold is-static-giada is-large is-centered is-rounded is-giada-green">{{isModalValuePosition}}</div>

    <h4 class="has-margin-t-4 has-text-white">{{isModalCallToActionTextTop}}</h4>
    <h4 class="has-margin-b-4 has-text-white">{{isModalCallToActionTextBottom}}</h4>
    <social-sharing :url="socialSharing.properties.url"
                    :title="socialSharing.properties.title"
                    :description="socialSharing.properties.description"
                    :quote="socialSharing.properties.quote"
                    :hashtags="socialSharing.properties.hashtags"
                    :twitter-user="socialSharing.properties.twitter_user"
                    :media="socialSharing.properties.media"
                    inline-template
                    @open="toogleCollapse"
                    :networks="socialSharing.overriddenNetworks">
      <div class="level has-text-centered is-mobile">
        <div class="level-item" >
          <network network="facebook" class="icon icon-button facebook">
              <i class="fab fa-facebook-f"></i>
              <span></span>
          </network>
        </div>
        <div class="level-item" >
          <network network="twitter" class="icon icon-button twitter">
              <i class="fab fa-twitter"></i>
              <span></span>
          </network>
        </div>
        <div class="level-item" >
          <network network="pinterest" class="icon icon-button pinterest">
              <i class="fab fa-pinterest-p"></i>
              <span></span>
          </network>
        </div>
        <div class="level-item" >
          <network network="linkedin" class="icon icon-button linkedin">
              <i class="fab fa-linkedin-in"></i>
              <span></span>
          </network>
        </div>
        <div class="level-item is-marginless">
          <network network="emailArray" class="icon icon-button envelope">
              <i class="fas fa-envelope"></i>
              <span></span>
          </network>
        </div>
      </div>
    </social-sharing>

    <b-collapse :open.sync="isOpen" class="has-margin-b-4">
      <div slot="trigger"></div>
      <div v-if="hasInvites===true">
        <!--<p class="has-text-left has-text-white" >{{listEmail.text}}</p>-->
        <p class="has-text-white has-margin-b-7">You have only <span class="has-text-giada-green has-text-weight-semibold"> {{maxInvites - currentInvites}} </span> invites, make it count!</p>
      </div>
      <div v-if="hasInvites===false">
        <p class="has-text-white has-margin-b-7">Great you used all your available invites.</p>
      </div>

      <form v-on:submit.prevent="beforeSubmitInvites" method="post" novalidate>

        <div class="field">
          <div class="control">
            <!-- taginput field -->
            <b-field :type="errors.has(nameField) ? 'is-danger' : ''">
              <b-taginput
                v-model="tags"
                :name="nameField"
                :ref="sharesInput"
                icon="envelope"
                :placeholder="listEmail.placeholder"
                size="is-small"
                type="is-danger"
                class="mailTag is-size-7 has-text-centered"
                :maxtags="6"
                rounded
                :ellipsis=true
                has-counter="false"
                @input="counterTags"
                @add="validateTag"
                @remove="updateTag"
                data-vv-validate-on="input"
                v-validate="'email'">
              </b-taginput>
            </b-field>
          </div>

          <!-- error field -->
          <span class="help is-danger has-text-left" v-if="errors.has(nameField)">
            <span class="is-right has-text-danger" v-if="errors.has(nameField) && (currentInvites === maxInvites)">
              <i class="fas fa-exclamation-circle"></i>
            </span>
            {{ errors.first(nameField) }}
          </span>
        </div>

        <!-- button field -->
        <div class="field">
          <div class="control">
            <button class="button is-rounded is-giada-green is-fullwidth">{{listEmail.buttonText}}</button>
          </div>
        </div>
     </form>
    </b-collapse>

  </div>
</template>

<script>
export default {
  name: 'SuccessSubmission',
  data: function () {
    return {
      nameField: 'email',
      tagHasErrors: false,
      sharesInput: 'sharesInput',
      tags: [],
      tagState: [],
      invites: {'emails': []},
      maxInvites: 5,
      currentInvites: '',
      hasInvites: true,
      isModalTextTitle: 'Great news, you’re in!',
      isModalTextSubTitleThanks: 'Thanks for signing up with us.',
      isModalTextSubTitle: 'You’re already on your way to feeling your best.',
      isModalTextPosition: 'Your current spot on our waitlist is:',
      isModalValuePosition: '64,234',
      isModalCallToActionTextTop: 'Want to move up on the list?',
      isModalCallToActionTextBottom: 'Gain early access by sharing with your friends.',
      socialSharing: {
        overriddenNetworks: {
          'emailArray': {
            'sharer': '',
            'type': 'direct'
          }
        },
        properties: {
          url: 'https://giada.ai', // URL to share
          title: 'Making the path to wellness easy.', // Sharing title (when available)
          description: 'I signed up for early access to @giada_ai, an #AI assistant on a mission to fix health care by putting the focus back on you, because you are what you eat. Check out more at https://giada.ai #wellnessbuddy #deeplearning #foodasmedicine', // Sharing description (when available)
          quote: 'OMG! Check it out. #wellnessbuddy #foodasmedicine #deeplearning #makingtheworldabetterplace', // Facebook quote (Facebook only)
          hashtags: 'ArtificialIntelligence, WellnessBuddy, HealthyEating, FoodAsMedicine, YouAreWhatYoueat, DeepLearning, AI', // A list of comma-separated hashtags (Twitter only)
          twitter_user: 'giada_ai', // Twitter user (Twitter only)
          media: 'https://landing-page-ver1.firebaseapp.com/static/social/og-image.jpg' // Url to a media (Pinterest only)
        }
      },
      isOpen: false,
      listEmail: {
        text: 'Please enter your favorite friends emails.', // 'Please enter a valid comma separated email list.',
        placeholder: 'Add an email', // 'e.g. john.doe@gmail.com, jane.doe@gmail.com',
        buttonText: 'Share it!'
      }
    }
  },
  methods: {
    setModalValuePosition: function () {
      this.isModalValuePosition = parseInt(this.$attrs.counter).toLocaleString()
    },
    toogleCollapse: function (network) {
      if (network === 'emailArray') {
        this.isOpen = !this.isOpen
      }
    },
    counterTags: function () {
      this.currentInvites = this.tags.length
      this.hasInvites = this.currentInvites < this.maxInvites
      let inputClass = this.$refs.sharesInput.$children[0].$el.classList
      if (this.currentInvites === this.maxInvites) {
        inputClass.add('is-invisible')
      } else {
        inputClass.remove('is-invisible')
      }
    },
    validateTag: function (tag) {
      this.$validator.validate('email', tag).then((result) => {
        this.$nextTick(() => {
          let tagClass = this.$refs.sharesInput.$children[1 + this.tags.indexOf(tag)].$el.classList
          if (!result) {
            tagClass.remove('is-giada-green')
            tagClass.add('is-danger')
          } else {
            tagClass.remove('is-danger')
            tagClass.add('is-giada-green')
          }
          let state = {}
          state['status'] = !result
          state['name'] = tag
          this.tagState.push(state)
        })
      })
    },
    updateTag: function (tag) {
      const oldIndex = (this.tagState.map(obj => obj.name)).indexOf(tag)
      for (let i = oldIndex; i < this.tags.length; i++) {
        this.$nextTick(() => {
          let tagClass = this.$refs.sharesInput.$children[i + 1].$el.classList

          if (!this.tagState[i].status) {
            tagClass.remove('is-danger')
            tagClass.add('is-giada-green')
          } else {
            tagClass.remove('is-giada-green')
            tagClass.add('is-danger')
          }
        })
      }
      this.tagState.splice(oldIndex, 1)
    },
    beforeSubmitInvites: function () {
      let invitees = []
      if (this.tags.length) {
        for (let i = 0; i < this.tags.length; ++i) {
          invitees[i] = {'email': this.tags[i]}
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            // this.$http.post('http://localhost:5000/landing-page-ver1/us-central1/giadaFunc/invite',
            this.$http.post('https://us-central1-landing-page-ver1.cloudfunctions.net/giadaFunc/invite',
              {
                sender: this.$attrs.sender,
                token: this.$attrs.token,
                invitees: invitees
              },
              {
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              }).then(() => {
              let inviteesLength = invitees.length
              for (let i = 0; i < inviteesLength; ++i) {
                this.$refs.sharesInput.$children[1 + i].$el.remove() // children[1].click() // .$children.$el.click()
              }
              // this.$parent.isActive = false //close and remove modal
              // this.$router.push('/')
              // this.maxInvites = this.maxInvites - inviteesLength
            })
          }
        })
      }
    }
  },
  mounted () {
    this.setModalValuePosition()
  }
}
</script>

<style type="scss">
  .mailTag.taginput .is-small.taginput-container.is-focusable {
    border-radius: 1rem;
  }

  .mailTag .help.counter {
    display: none;
  }

  .notShowed {
    display: none;
  }

  .is-static-giada {
    box-shadow: none;
    pointer-events: none;
  }

  .is-card {
    background-color: rgba(255,255,255,0.2);
    border-radius: 1.5rem;
    padding: 1rem 3rem;
  }

  @media only screen and (min-width: 768px) {
    .is-card {
      margin-left: 6rem;
      margin-right: 6rem;
    }
  }

  .is-action {
    color: #FFFFFF;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  /* Wrapper */
  .icon.icon-button {
    background-color: rgba(255,255,255,1);
    font-size: 0.9rem;
    height: 1.8rem;
    width: 1.8rem;
    border-radius: 1.8rem;
    line-height: 1.8rem;
    cursor: pointer;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: background-color 0.3s;
    -moz-transition: background-color 0.3s;
    -o-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }

  .icon.icon-button:hover {
    background-color: rgba(255,255,255,0);
  }

  /* Circle */
  .icon-button span {
    border-radius: 0;
    height: 0;
    width: 0;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    z-index: 0;
  }

  .icon-button:hover span {
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 1.8rem;
    margin: -0.9rem;
  }

  /* Icons */
  .icon-button i {
    background: none;
    color: rgba(255,255,255,0);
    height: 1.8rem;
    width: 1.8rem;
    line-height: 1.8rem;
    position: absolute;
    left: 0;
    top: 0;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }

  @media only screen and (min-width: 768px) {
    .icon.icon-button {
      font-size: 1.25rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 2.5rem;
      line-height: 2.5rem;
    }

    .icon-button:hover span {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 2.5rem;
      margin: -1.25rem;
    }

    .icon-button i {
      height: 2.5rem;
      line-height: 2.5rem;
      width: 2.5rem;
    }
  }

  .envelope span,
  .facebook span,
  .twitter span,
  .pinterest span,
  .linkedin span {
    background-color: #19B49B;
  }

  .icon-button .fa-envelope,
  .icon-button .fa-facebook-f,
  .icon-button .fa-twitter,
  .icon-button .fa-pinterest-p,
  .icon-button .fa-linkedin-in {
    color: #19B49B;
    z-index: 1;
  }

  .icon-button .fa-envelope,
  .icon-button .fa-facebook-f,
  .icon-button .fa-twitter,
  .icon-button .fa-pinterest-p,
  .icon-button .fa-linkedin-in {
    color: #19B49B;
  }

  .icon-button:hover .fa-envelope,
  .icon-button:hover .fa-facebook-f,
  .icon-button:hover .fa-twitter,
  .icon-button:hover .fa-pinterest-p,
  .icon-button:hover .fa-linkedin-in {
    color: rgba(255,255,255,1);
  }

  /* Envelope */
  /*.envelope span {
    background-color: #D095E9;
  }*/

  /*.icon-button .fa-envelope {
    color: #D095E9;
    z-index: 1;
  }*/

  /* Facebook */
  /*.facebook span {
    background-color: #3B5998;
  }*/

  /*.icon-button .fa-facebook-f {
    color: #3B5998;
    z-index: 1;
  }*/

  /* Twitter */
  /*.twitter span {
    background-color: #1da1f2;
  }*/

  /*.icon-button .fa-twitter {
    color: #1da1f2;
    z-index: 1;
  }*/

  /* Pinterest */
  /*.pinterest span {
    background-color: #bd081c;
  }*/

  /*.icon-button .fa-pinterest-p {
    color: #bd081c;
    z-index: 1;
  }*/

  /* Linkedin */
  /*.linkedin span {
    background-color: #007bb5;
  }*/

  /*.icon-button .fa-linkedin-in {
    color: #007bb5;
    z-index: 1;
  }*/

  /* Instagram */
  /*$instagram-color: linear-gradient( #400080, transparent), linear-gradient(200deg, #d047d1, #ff0000, #ffff00);*/

</style>



// WEBPACK FOOTER //
// src/components/landingPage/SuccessSubmission.vue